import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core/lib/contracts/IHttpBasicResponse';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IGmbAnalytics, IGMBReviews, IStoreAnalytics } from '../contracts/IAnalitycs';
import { IGmbLocation } from '../contracts/ILocation';
import {
  GMB_REPOSITORY,
  IGmbRepository,
  ISetAuthCodePayload,
} from '../reposiitories/IGmb.repository';
import { IGmbService } from './IGmb.service';

@Injectable()
export class GmbService implements IGmbService {
  constructor(@Inject(GMB_REPOSITORY) private repository: IGmbRepository) {}

  getLocation(): Observable<{ status: GMB_STATUS; data: IGmbLocation }> {
    return this.repository.getLocation().pipe(
      map((payload) => {
        // const response: { status: GMB_STATUS; data: IGmbLocation } = {
        //   status: payload?.data?.locationState
        //     ? payload?.data?.locationState?.isPublished &&
        //       payload?.data?.locationState?.isVerified
        //       ? 'VERIFIED'
        //       : 'IN_PROCESS'
        //     : 'NO_GMB',
        //   data: payload?.data,
        // };
 
        const response: { status: GMB_STATUS; data: IGmbLocation } = {
          status: payload?.data?.attributes?.title
              ? 'VERIFIED'
            : 'NO_GMB',
          data: payload?.data,
        };
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.message === 'No GMB product found for this user.') {
          const response: { status: GMB_STATUS; data: IGmbLocation } = {
            status: 'NO_GMB',
            data: null,
          };

          return of(response);
        } else {
          console.error('GmbService getLocation(error)', error);
          throw error;
        }
      })
    );
  }

  getAuthCode(accessToken: any, idToken: any): Observable<any> {
    return this.repository
      .getAuthCode(accessToken, idToken)
      .pipe(map((response) => response));
  }

  getAnalytics(customFiler: any): Observable<IGmbAnalytics> {
    return this.repository
      .getAnalytics(customFiler)
      .pipe(map((response) => response.data));
  }

  getGMBReviews(): Observable<IGMBReviews> {
    return this.repository
      .getGMBReviews()
      .pipe(map((response) => response.data));
  }

  getStoreAnalytics(customFiler: any): Observable<IStoreAnalytics> {
    return this.repository
      .getStoreAnalytics(customFiler)
      .pipe(map((response) => response.data));
  }

  getAccumulatedAnalytics(customFiler: any): Observable<any> {
    return this.repository
      .getAccumulatedAnalytics(customFiler)
      .pipe(map((response) => response.data));
  }

  setAuthCode(payload: ISetAuthCodePayload): Observable<IGmbLocation[]> {
    return this.repository
      .setAuthCode(payload)
      .pipe(map((response) => response.data.attributes));
  }

  setSelectedLocation(payload: IGmbLocation) {
    return this.repository
      .setSelectedLocation(payload)
      .pipe(map((response) => response.data.attributes));
  }

  getGMBCategories(query: string): Observable<JsonApiResponse<any>> {
    return this.repository
      .getGMBCategories(query)
      .pipe(map((response) => response.data.attributes));
  }

  createGBP(payload: any): Observable<any> {
    return this.repository
      .createGBP(payload)
      .pipe(map((response) => response));
  }

  verifyGBP(payload: any): Observable<any> {
    return this.repository
      .verifyGBP(payload)
      .pipe(map((response) => response));
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type GMB_STATUS = 'NO_GMB' | 'IN_PROCESS' | 'VERIFIED';
